import { identityBasePart } from "./constants";

export default {
  all: () => `${identityBasePart}/organizations`,
};
